import proj4 from 'proj4'
import { REQ_SEARCH_ADDRESS, REQ_ADDRESS_POS } from '@/store/_actions/actionTypes'
import { NETWORK_ERROR_MESSAGE } from '@/utils/Message'
import { regexForEmoticaon } from '@/utils/CommonForVue'
import service from '@/backend/modnpay_app_api'
import Vue from 'vue'
export default Vue.extend({

  data () {
    return {
      openAddressDetail: false,
      addressIcon: ['homeIcon', 'companyIcon', 'etcIcon'], // 주소 아이콘
      addressName: ['우리집', '회사'],
      selectAddress: {}, // 선택 주소
      addressIndex: '',
      modalToggle: false,
      message: '', // 모달 메세지
      addressLength: 0, // 주소갯수
      homeActiveFlag: false, // 우리집클릭
      updateType: 2, // 1:수정 2:등록
      position: {}, // Gps 좌표
      recentAddress: [],
      searchFlag: false,
      keyword: '', // 주소 검색 keyword
      tempKeyword: '', // 이전 keyword
      pageNo: 0, // 요청하는 주소 리스트의 page 번호
      lastPageFlag: true, // 검색 요청 마지막 페이지
      searchAddress: [] // 주소 검색 결과
    }
  },
  computed: {
    // 최근주소 최대 3개 표시
    recentAddressArr () {
      return this.recentAddress.slice(0, 3)
    },
    getSelectedAddress () {
      return this.$store.getters.selectedAddress
    }
  },
  watch: {
    keyword () {
      if (this.keyword.length === 0) {
        this.searchAddress = []
        this.lastPageFlag = true
      }
    },
    getSelectedAddress (newVal, oldVal) {
      console.log('## watch getSelectedAddress')
      console.log(newVal)
      const tempKeyword = newVal?.roadAddress || newVal?.address
      if (tempKeyword) {
        this.keyword = tempKeyword
        this.onClickSearchBtn()
      }
    }
  },
  created () {
    this.resetRecentAddress()
  },
  methods: {
    reqNextPage ($state) { this.onClickSearchBtn($state) },
    // ㅡㅡㅡㅡㅡㅡㅡ 유효성검사 ㅡㅡㅡㅡㅡㅡㅡ //
    onCheckInput () { // 검색 keyword 유효성 검사
      console.log(this.keyword)
      // 특수문자와 영어 제거
      // const pattern = /[$\\@\\#%^&*()[\]+_{}`~=|!;:''"",<>.?a-zA-Z]/
      const pattern = /[$\\@\\#%^&*()[\]+_{}`~=|!;:''"",<>.?]/g
      this.keyword = this.keyword.replace(pattern, '')
      this.keyword = this.keyword.replace(regexForEmoticaon, '')
    },
    // ㅡㅡㅡㅡㅡㅡㅡ 웹 주소 설정 ㅡㅡㅡㅡㅡㅡㅡ //
    onClickSearchBtn (state) { // 주소 검색
      if (this.tempKeyword !== this.keyword) { // 이전 키워드 비교
        this.searchAddress = []
        this.lastPageFlag = true
      }
      this.tempKeyword = this.keyword // 이전 키워드 저장
      this.searchFlag = true
      if (this.lastPageFlag) { // 검색 버튼 클릭시
        this.pageNo = 1
      }
      const reqSearchAddress = {
        lang: this.$i18n.locale,
        keyword: this.keyword,
        pageNo: this.pageNo
      }

      this.$store.dispatch(REQ_SEARCH_ADDRESS, reqSearchAddress)
        .then((responsedData) => {
          const errorCode = responsedData.common.errorCode
          // 에러가 있는 경우
          if (/^E/.test(errorCode)) {
            this.searchAddress = []
          } else {
            if (this.lastPageFlag) this.searchAddress = []
            this.searchAddress = this.searchAddress.concat(responsedData.juso)
            if (responsedData.juso.length === 0) { // 마지막 페이지
              this.lastPageFlag = true
            } else {
              this.lastPageFlag = false
              this.pageNo++
              if (state) state.loaded()
            }
          }
        }).catch(() => this.toast(this, NETWORK_ERROR_MESSAGE))
    },
    chooseAddress (clickedAddress) { // 주소 검색 결과 click event
      console.log('## chooseAddress')
      this.$store.dispatch(REQ_ADDRESS_POS, clickedAddress)
        .then((responsedData) => {
          this.searchFlag = false
          this.updateType = 2
          this.keyword = ''
          this.position = this.getGPS(responsedData.juso)
          // this.$emit('update:position', this.getGPS(responsedData.juso))
          this.selectAddress = clickedAddress
          // this.$emit('update:selectAddress', clickedAddress)
          // this.$emit('hideDoubleBtnDialog')
          this.createPopUp('#appDetail.cusLayer')
        }).catch(() => this.toast(this, NETWORK_ERROR_MESSAGE))
    },
    // ㅡㅡㅡㅡㅡㅡㅡ 좌표계 ㅡㅡㅡㅡㅡㅡㅡ //
    // 경위도 좌표계가 서버와 달라서
    // 서버에서 사용하는 좌표계로 변경해주는 코드
    getGPS (juso) {
      proj4.defs['EPSG:5179'] = '+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs' // 제공되는 좌표
      const grs80 = proj4.Proj(proj4.defs['EPSG:5179'])
      const wgs84 = proj4.Proj(proj4.defs['EPSG:4326']) // 경위도
      let p = proj4.Point(parseFloat(juso[0].entX), parseFloat(juso[0].entY)) // 한국지역정보개발원 좌표
      p = proj4.transform(grs80, wgs84, p)
      return p
    },
    // ㅡㅡㅡㅡㅡㅡㅡ 최근 주소 저장 ㅡㅡㅡㅡㅡㅡㅡ //
    resetRecentAddress () {
      const storageData = localStorage.getItem('recentAddress')
      if (!storageData) {
        const firstAddress = JSON.parse(sessionStorage.getItem('selectAddress'))
        if (firstAddress != null) {
          if (firstAddress.emdNm !== undefined) {
            this.recentAddress[0] = firstAddress
            localStorage.setItem('recentAddress', JSON.stringify(this.recentAddress))
          }
        }
        // localStorage.setItem('recentAddress', JSON.stringify(this.recentAddress))
      } else {
        this.recentAddress = JSON.parse(storageData)
      }
    },
    // ㅡㅡㅡㅡㅡㅡㅡ address delete ㅡㅡㅡㅡㅡㅡㅡ //
    async addressDel () { // 주소삭제
      const req = {
        appUserAddressId: this.addressList[this.addressIndex].appUserAddressId
      }
      const { data } = await service.addressDelete(req)
      if (data.resultCode === 0) {
        this.$emit('addresslist')
      }
    },
    deleteRecentAddress (index) { // 최근주소 삭제
      this.recentAddress.splice(index, 1)
      localStorage.setItem('recentAddress', JSON.stringify(this.recentAddress))
      this.resetRecentAddress()
    },
    // ㅡㅡㅡㅡㅡㅡㅡdetailTypeㅡㅡㅡㅡㅡㅡㅡ //
    addressDetailUpdate (index) {
      this.selectAddress = this.addressList[index]
      this.homeActiveFlag = false
      this.updateType = 1 // 수정으로 디테일이동
      this.createPopUp('#appDetail.cusLayer')
    },
    openSerachPopUp (Flag) {
      this.updateType = 2 // 등록으로 디테일이동
      this.homeActiveFlag = Flag
      this.addressLength = this.addressList.length
      this.createPopUp('#appAddress.cusLayer')
    },

    // ㅡㅡㅡㅡㅡㅡㅡsetAddressㅡㅡㅡㅡㅡㅡㅡ //
    async setMainAddress (selectAddress) { // 저장된 주소에서 메인주소 선택
      const req = {
        appUserAddressId: selectAddress.appUserAddressId
      }
      const { data } = await service.addressDefaultSetting(req)
      if (data.resultCode === 0) {
        this.removePopUp()
        if (this.appFlag) this.onClickCloseBtn()
        else this.appMoveMain()
      }
    },
    addresslist () { // detail 페이지 등록,수정 후 addressList 재호출
      this.$emit('addresslist')
    },
    onClickRecentAddress (address) {
      this.position.x = address.x
      this.position.y = address.y
      this.selectAddress = address
      this.createPopUp('#appDetail.cusLayer')
    },
    // ㅡㅡㅡㅡㅡㅡㅡpopupㅡㅡㅡㅡㅡㅡㅡ //
    onClickCloseBtn () {
      this.searchFlag = false
      this.keyword = ''
      this.removeDim()
      this.idRemovePopUp('#app.cusLayer')
      this.$emit('closePopUp')
    },
    // ㅡㅡㅡㅡㅡㅡㅡmodalㅡㅡㅡㅡㅡㅡㅡㅡㅡ //
    toggleModal () {
      this.modalToggle = !this.modalToggle
    },
    openModal (index) { // 주소삭제 모달
      this.addressIndex = index
      this.message = '이 주소를 삭제하시겠습니까?'
      this.toggleModal()
    },
    modalCheck () {
      this.addressDel()
      this.toggleModal()
    }
  }
})
